import {
	Button,
	ButtonGroup,
	Card,
	CardContent,
	Dimmer,
	Header,
	Icon,
	Label,
	Loader,
	Modal,
	ModalActions,
	ModalContent,
	ModalHeader,
} from "semantic-ui-react";
import { memo, useEffect, useState } from "react";
import { DocumentCard } from "./DocumentCard";
import { formatTime } from "utils/dateUtils";
import { isMobile } from "utils/isMobile";

const DocumentCardMemo = memo(DocumentCard);

export const PrescriptionsDocumentViewer = ({ open, folder, prescriptions, onClose, onFolderOpen, getAllPrescriptionScans }) => {
	const [currentPrescription, setCurrentPrescription] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [scans, setScans] = useState([]);

	useEffect(() => {
		setScans([]);

		if (!isLoading && prescriptions && prescriptions[currentPrescription]) {
			setIsLoading(true);
			getAllPrescriptionScans(prescriptions[currentPrescription].id).then((res) => {
				if (res.payload.data) {
					setScans(res.payload.data.scans);
					setTimeout(() => setIsLoading(false), 500);
				}
			});
		}
	}, [getAllPrescriptionScans, currentPrescription]);

	if (!prescriptions || !prescriptions.length || !prescriptions[currentPrescription]) {
		return null;
	}

	return (
		<Modal open={open} onClose={onClose}>
			<ModalHeader
				style={{
					display: "flex",
					justifyContent: "space-between",
				}}
			>
				Voir les documents
			</ModalHeader>
			<ModalContent>
				<Card style={{ width: "100%" }}>
					<CardContent style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", flexDirection: isMobile() ? "column" : "row" }}>
						<div>
							<Icon name="doctor" />
							<b>Prescription № {currentPrescription + 1}</b>
						</div>
						<div>
							<b>MÉDECIN :</b> {prescriptions[currentPrescription]?.prescriber?.title} {prescriptions[currentPrescription]?.prescriber?.first_name}{" "}
							{prescriptions[currentPrescription]?.prescriber?.last_name}
						</div>
						<div>
							Délivrance : <b>{formatTime(prescriptions[currentPrescription]?.issue_date)}</b>
						</div>
						<div>
							Validité : <b>{formatTime(prescriptions[currentPrescription]?.validity_date)}</b>
						</div>
					</CardContent>
				</Card>
				<Header as="h5">
					<Icon name="file alternate" />
					Documents ({scans.length})
				</Header>
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						flexWrap: "wrap",
						width: "100%",
						padding: "10px",
						maxHeight: "500px",
						overflowY: "auto",
						gap: "100px",
					}}
				>
					{isLoading && (
						<Dimmer active>
							<Loader>Chargement</Loader>
						</Dimmer>
					)}

					{!isLoading &&
						prescriptions &&
						prescriptions[currentPrescription] &&
						scans.map((scan, index) => <DocumentCardMemo document={scan} key={index} />)}
				</div>
			</ModalContent>
			<ModalActions>
				<div style={{ display: "flex", justifyContent: "space-between", flexDirection: isMobile() ? "column" : "row", gap: isMobile() ? 10 : 0 }}>
					{prescriptions.length > 1 && (
						<ButtonGroup>
							<Button
								onClick={(e) => {
									if (currentPrescription !== 0) {
										setCurrentPrescription(currentPrescription - 1);
									}
								}}
							>
								<Icon name="arrow alternate left" size={20} />
							</Button>
							<Button color="orange">
								Prescription {currentPrescription + 1} / {prescriptions.length}
							</Button>
							<Button
								onClick={(e) => {
									if (currentPrescription !== prescriptions.length - 1) {
										setCurrentPrescription(currentPrescription + 1);
									}
								}}
							>
								<Icon name="arrow alternate right" size={20} />
							</Button>
						</ButtonGroup>
					)}
					<ButtonGroup>
						<Button color="blue" onClick={() => onClose()}>
							Fermer
						</Button>
						{/* <Button
							color="green"
							onClick={() => onFolderOpen()}
							disabled={!(folder.status !== "HELP_NURSE" && !folder.openedBy && !folder.is_express)}
						>
							Ouvrir le dossier
						</Button> */}
					</ButtonGroup>
				</div>
			</ModalActions>
		</Modal>
	);
};
